export let showLeftPaneButton = "IAYH3";
export let hideLeftPaneButton = "FMLcIe";
export default {showLeftPaneButton,hideLeftPaneButton};